import "core-js/modules/es.array.reverse.js";
var _class, _class2, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import "core-js/modules/web.dom-collections.iterator.js";
import { action, makeObservable, observable, reaction } from "mobx";
import { observer } from "mobx-react";
import { Component } from "react";
import Ellipsoid from "terriajs-cesium/Source/Core/Ellipsoid";
import CesiumMath from "terriajs-cesium/Source/Core/Math";
import markerIcon from "../../../../wwwroot/images/difference-pin.png";
import { addMarker, removeMarker } from "../../../Models/LocationMarkerUtils";
import MapInteractionMode, { UIMode } from "../../../Models/MapInteractionMode";
import Loader from "../../Loader";
import { jsx as _jsx } from "react/jsx-runtime";
let LocationPicker = observer(_class = (_class2 = class LocationPicker extends Component {
  constructor(props) {
    super(props);
    _initializerDefineProperty(this, "pickMode", _descriptor, this);
    _initializerDefineProperty(this, "currentPick", _descriptor2, this);
    _initializerDefineProperty(this, "pickDisposer", _descriptor3, this);
    makeObservable(this);
  }
  setupPicker() {
    const {
      terria,
      location,
      onPicking,
      onPicked
    } = this.props;
    this.pickMode = new MapInteractionMode({
      message: "",
      messageAsNode: /*#__PURE__*/_jsx("div", {}),
      uiMode: UIMode.Difference
    });
    addInteractionModeToMap(terria, this.pickMode);
    if (location) showMarker(terria, location);
    this.pickDisposer = reaction(() => this.pickMode.pickedFeatures, action(newPick => {
      var _newPick$allFeaturesA;
      if (newPick === undefined || newPick.pickPosition === undefined) {
        return;
      }
      this.pickMode.customUi = () => /*#__PURE__*/_jsx(Loader, {
        message: "Querying ".concat(location ? "new" : "", " position...")
      });
      const position = cartesianToDegrees(newPick.pickPosition);
      showMarker(this.props.terria, position);
      this.currentPick = newPick;
      onPicking(position);
      (_newPick$allFeaturesA = newPick.allFeaturesAvailablePromise) === null || _newPick$allFeaturesA === void 0 || _newPick$allFeaturesA.then(() => {
        if (newPick === this.currentPick) {
          onPicked(newPick, position);
        }
      });
    }));
  }
  destroyPicker() {
    var _this$pickDisposer;
    const {
      terria
    } = this.props;
    if (this.pickMode) {
      removeInteractionModeFromMap(terria, this.pickMode);
    }
    removeMarker(terria);
    this.pickMode = undefined;
    this.currentPick = undefined;
    (_this$pickDisposer = this.pickDisposer) === null || _this$pickDisposer === void 0 || _this$pickDisposer.call(this);
    this.pickDisposer = undefined;
  }
  componentDidMount() {
    this.setupPicker();
  }
  componentDidUpdate() {
    this.destroyPicker();
    this.setupPicker();
  }
  componentWillUnmount() {
    this.destroyPicker();
  }
  render() {
    return null;
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "pickMode", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "currentPick", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "pickDisposer", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "setupPicker", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "setupPicker"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "destroyPicker", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "destroyPicker"), _class2.prototype), _class2)) || _class;
export { LocationPicker as default };
function addInteractionModeToMap(terria, mode) {
  terria.mapInteractionModeStack.push(mode);
}
function removeInteractionModeFromMap(terria, mode) {
  const [currentMode] = terria.mapInteractionModeStack.slice(-1);
  if (currentMode === mode) {
    terria.mapInteractionModeStack.pop();
  }
}
function showMarker(terria, location) {
  addMarker(terria, {
    name: "User selection",
    location,
    customMarkerIcon: markerIcon
  });
}
function cartesianToDegrees(cartesian) {
  const carto = Ellipsoid.WGS84.cartesianToCartographic(cartesian);
  return {
    longitude: CesiumMath.toDegrees(carto.longitude),
    latitude: CesiumMath.toDegrees(carto.latitude)
  };
}